import styled from "styled-components";

export const FormContainer = styled.div`
  width: 400px;
  margin: 0 auto 30px auto;

  @media screen and (max-width: 600px) {
    width: 350px;
    padding: 0 5px;
  }
`;
